import React, { Component } from "react";
import { AppContext } from "./App";
export default class Store extends Component {
  render() {
    return (
      <AppContext.Consumer>
        {({ store }) => this.props.render(store)}
      </AppContext.Consumer>
    );
  }
}
